var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 75,
    viewBox: "0 0 120 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    fill: "#2E488B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.5446,
    y: -11.4331,
    width: 180,
    height: 8,
    transform: "rotate(30.4591 -13.5446 -11.4331)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.5446,
    y: -11.4331,
    width: 180,
    height: 8,
    transform: "rotate(30.4591 -13.5446 -11.4331)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.5446,
    y: -11.4331,
    width: 180,
    height: 8,
    transform: "rotate(30.4591 -13.5446 -11.4331)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.5446,
    y: -11.4331,
    width: 180,
    height: 8,
    transform: "rotate(30.4591 -13.5446 -11.4331)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.5446,
    y: -11.4331,
    width: 180,
    height: 8,
    transform: "rotate(30.4591 -13.5446 -11.4331)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.5446,
    y: -11.4331,
    width: 180,
    height: 8,
    transform: "rotate(30.4591 -13.5446 -11.4331)",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.012,
    y: -9.3797,
    width: 177,
    height: 5,
    transform: "rotate(30.4591 -13.012 -9.3797)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.012,
    y: -9.3797,
    width: 177,
    height: 5,
    transform: "rotate(30.4591 -13.012 -9.3797)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.012,
    y: -9.3797,
    width: 177,
    height: 5,
    transform: "rotate(30.4591 -13.012 -9.3797)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.012,
    y: -9.3797,
    width: 177,
    height: 5,
    transform: "rotate(30.4591 -13.012 -9.3797)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.012,
    y: -9.3797,
    width: 177,
    height: 5,
    transform: "rotate(30.4591 -13.012 -9.3797)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.6132,
    y: 77.8144,
    width: 180,
    height: 8,
    transform: "rotate(-30.46 -18.6132 77.8144)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.6132,
    y: 77.8144,
    width: 180,
    height: 8,
    transform: "rotate(-30.46 -18.6132 77.8144)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.6132,
    y: 77.8144,
    width: 180,
    height: 8,
    transform: "rotate(-30.46 -18.6132 77.8144)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.6132,
    y: 77.8144,
    width: 180,
    height: 8,
    transform: "rotate(-30.46 -18.6132 77.8144)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.6132,
    y: 77.8144,
    width: 180,
    height: 8,
    transform: "rotate(-30.46 -18.6132 77.8144)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.6132,
    y: 77.8144,
    width: 180,
    height: 8,
    transform: "rotate(-30.46 -18.6132 77.8144)",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.5598,
    y: 78.3469,
    width: 177,
    height: 5,
    transform: "rotate(-30.46 -16.5598 78.3469)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.5598,
    y: 78.3469,
    width: 177,
    height: 5,
    transform: "rotate(-30.46 -16.5598 78.3469)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.5598,
    y: 78.3469,
    width: 177,
    height: 5,
    transform: "rotate(-30.46 -16.5598 78.3469)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.5598,
    y: 78.3469,
    width: 177,
    height: 5,
    transform: "rotate(-30.46 -16.5598 78.3469)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.5598,
    y: 78.3469,
    width: 177,
    height: 5,
    transform: "rotate(-30.46 -16.5598 78.3469)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 28.5,
    width: 123,
    height: 18,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 28.5,
    width: 123,
    height: 18,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 28.5,
    width: 123,
    height: 18,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 28.5,
    width: 123,
    height: 18,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 28.5,
    width: 123,
    height: 18,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 28.5,
    width: 123,
    height: 18,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 76.5,
    width: 78,
    height: 18,
    transform: "rotate(-90 50.5 76.5)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 76.5,
    width: 78,
    height: 18,
    transform: "rotate(-90 50.5 76.5)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 76.5,
    width: 78,
    height: 18,
    transform: "rotate(-90 50.5 76.5)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 76.5,
    width: 78,
    height: 18,
    transform: "rotate(-90 50.5 76.5)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 76.5,
    width: 78,
    height: 18,
    transform: "rotate(-90 50.5 76.5)",
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 76.5,
    width: 78,
    height: 18,
    transform: "rotate(-90 50.5 76.5)",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 120,
    height: 15,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 120,
    height: 15,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 120,
    height: 15,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 120,
    height: 15,
    fill: "#E34545"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 120,
    height: 15,
    fill: "#E34545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 75,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.0d81c0713d6d5eef8eb93e44bd06aa2c.svg";
export { ForwardRef as ReactComponent };